import { UserGrantType } from "../enums";

/**
 * Full role names, for listing who holds which role on a resource. Distinct from
 * `getCurrentUserPermissionLabel`, whose terser copy ("Admin", "View") labels the viewer's own
 * permission rather than naming a role.
 */
export function roleLabel(role: UserGrantType): string {
  switch (role) {
    case UserGrantType.viewer:
      return "Viewer";
    case UserGrantType.editor:
    case UserGrantType.upstreamRemoteEditOwner:
      return "Editor";
    case UserGrantType.owner:
    case UserGrantType.upstreamRemoteOwner:
      return "Owner";
    case UserGrantType.administrator:
      return "Administrator";
    case UserGrantType.executor:
      return "Executor";
  }
}
